export const skipUrl = () => {
    if (window.location.href.includes('localhost')) {
        const url = {
            h5_url: window.location.href,
            pc_url: window.location.href,
            tab_url: window.location.href
        }
        return url
    } else {
        const url = {
            h5_url: process.env.VUE_APP_H5_SKIP_URL,
            pc_url: process.env.VUE_APP_PC_SKIP_URL,
            tab_url: process.env.VUE_APP_TAB_SKIP_URL
        }
        // 线上跳转
        return url
    }
}
export const getWindowInfo = (params) => {
    const windowInfo = {
        width: window.innerWidth,
        height: window.innerHeight
    }
    // 屏幕尺寸小于700(移动端)
    if(windowInfo.width < 700) {
        if (window.location.href.includes(params.h5_url)) return
        window.location.href = params.h5_url
    }
    // 屏幕尺寸大于700(pc端)
    if (windowInfo.width >= 700) {
        if (window.location.href.includes(params.pc_url)) return
        window.location.href = params.pc_url
    }
}

// 通过ua 判断是pc还是mobile
export const detectDeviceType = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 检查是否是移动设备
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
        return 'Mobile';
    }

    // 检查是否是PC
    if (/Windows|Macintosh|Linux/i.test(userAgent)) {
        return 'PC';
    }

    return 'Unknown';
}

// 格式化费用
export const formatAmount = (num) => {
    let newNum = Number(num)
    if (newNum == 0) {
        newNum = ''
    } else if(newNum > 0) {
        if (newNum >= 10000) {
            newNum = newNum / 10000 + 'w'
        } else{
            newNum = newNum
        }
    }
    return newNum
}
        //画布添加水印
const drawWaterMark = (ctx, imgWidth, imgHeight, wmConfig) => {
    let fontSize;
    if (imgWidth >= 3456) {
      fontSize = 50;
    } else if (imgWidth >= 2700) {
      fontSize = 30;
    } else if (imgWidth >= 2000) {
      fontSize = 26;
    } else if (imgWidth >= 1436) {
      fontSize = 20;
    } else if (imgWidth >= 800) {
      fontSize = 12;
    } else if (imgWidth >= 500) {
      fontSize = 10;
    } else {
      fontSize = 8;
    }
    ctx.font = `${fontSize}px ${wmConfig.font}`;
    ctx.lineWidth = 1;
    ctx.fillStyle = "rgba(128,128,128,.3)";  //根据页面的背景色来设置水印颜色
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";

    //文字坐标
    const maxPx = Math.max(imgWidth, imgHeight);
    if (maxPx < 4300) {
        wmConfig.density = 4
    } else if(maxPx >= 4300 && maxPx < 10000) {
        wmConfig.density = 8
    } else if (maxPx >= 10000 && maxPx < 40000) {
        wmConfig.density = 30
    } else if(maxPx >= 40000){
        wmConfig.density = 50
    }
    console.log(wmConfig.density, maxPx, 'maxPx' )
    const stepPx = Math.floor(maxPx / wmConfig.density);
    let arrayX = [0]; //初始水印位置 canvas坐标 0 0 点
    while (arrayX[arrayX.length - 1] < maxPx / 2) {
      arrayX.push(arrayX[arrayX.length - 1] + stepPx);
    }
    arrayX.push(
      ...arrayX.slice(1, arrayX.length).map((el) => {
        return -el;
      })
    );

    const lineHeightFactor = 1; // 行间距的倍数
    for (let i = 0; i < arrayX.length; i++) {
      for (let j = 0; j < arrayX.length; j++) {
        ctx.save();
        ctx.translate(imgWidth / 2, imgHeight / 2); ///画布旋转原点 移到 图片中心
        ctx.rotate(-Math.PI / 5);
        if (wmConfig.textArray.length > 3) {
          wmConfig.textArray = wmConfig.textArray.slice(0, 3);
        }
        wmConfig.textArray.forEach((el, index) => {
          let offsetY = fontSize * index * lineHeightFactor + 15;
          ctx.fillText(el, arrayX[i], arrayX[j] + offsetY);
        });
        ctx.restore();
      }
    }
  }

export  const base64AddWaterMaker = (base64Img, wmConfig) => {
    if (wmConfig.textArray.length === 0) {
      console.error("****没有水印内容*****");
      return base64Img;
    }

    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      let resultBase64 = null;
      img.onload =  ()=> {
        canvas.width = img.width;
        canvas.height = img.height;
        //canvas绘制图片，0 0  为左上角坐标原点
        ctx.drawImage(img, 0, 0);
        //写入水印
        drawWaterMark(ctx, img.width, img.height, wmConfig);
        resultBase64 = canvas.toDataURL("image/png");
        console.log(resultBase64);
        if (!resultBase64) {
          reject();
        } else {
          resolve(resultBase64);
        }
      };
      img.src = base64Img;
    });
  }


 export const digitUppercase = (n) => {
    const fraction = ['角', '分'];
    const digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    const unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    
    // 处理负数
    let head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    
    let s = '';
    
    // 处理小数部分
    for (let i = 0; i < fraction.length; i++) {
        const decimal = Math.floor(n * 10 * Math.pow(10, i)) % 10;
        s += (digit[decimal] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    
    // 处理整数部分
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = '';
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            const num = n % 10;
            p = digit[num] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    
    // 处理连续的零和结尾的零
    s = head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
    
    return s;
}


export function convertRes2Blob(response) {
    // 提取文件名
    let fileName = ''
    // if (response.headers['content-disposition'].indexOf('UTF-8') > 0) {
    //     fileName = decodeURI(response.headers['content-disposition'].match(/filename=UTF-8''(.+)/)[1])
    // } else {
    //     fileName = decodeURI(response.headers['content-disposition'].match(/filename=(.*)/)[1])
    // }
    // const fileName = decodeURI(response.headers['content-disposition'].match(/filename=(.*)/)[1])
    // 将二进制流转为blob
    const blob = new Blob([response.data], { type: 'application/pdf' })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, decodeURI(fileName))
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', decodeURI(fileName))
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  }

  // 占位符
  export const dashPlaceholder = '--'
